import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { lastValueFrom, Observable } from 'rxjs';

import { ApThemeService } from '@ap/theme';

import { ApContentService } from '../content.service';

import { XCHeadlessContentResult } from './headless.model';

@Injectable({
    providedIn: 'root'
})
export class ApHeadlessContentService {
    private readonly httpClient = inject(HttpClient);
    private readonly themeService = inject(ApThemeService);

    public getContentItems(application: string): Observable<{ [key: string]: string }> {
        return this.httpClient.get(`/feed/fep-${this.getHeadlessTheme()}?all=${application}`).pipe(
            map((result: XCHeadlessContentResult) =>
                result.feed?.mediaitems
                    ?.filter((headlessItem) => headlessItem.value || headlessItem.elements?.length > 0)
                    .reduce(
                        (contentObject, headlessItem) => ({
                            ...contentObject,
                            [headlessItem.key]: headlessItem.value || headlessItem.elements[0].html
                        }),
                        {}
                    )
            )
        );
    }

    private getHeadlessTheme(): string {
        if (this.themeService.getTheme() === 'reb') {
            return 'regiobank';
        }
        return this.themeService.getTheme();
    }
}

export function headlessContentFactory(application: string) {
    return (headlessContentService: ApHeadlessContentService, contentService: ApContentService) => async () => {
        try {
            const result = await lastValueFrom(headlessContentService.getContentItems(application));
            return contentService.addHeadlessContentItems(result);
        } catch (err) {
            console.error(err); //NOSONAR
        }
    };
}
